import template from './finance-group-modal.pug';

export const FinanceGroupModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class FinanceGroupModalComponent {
    constructor($async, $log, Finance, AlertBox) {
      'ngInject';
      this.Finance = Finance;
      this.AlertBox = AlertBox;
      this.$log = $log;
      this.save = $async(this.save.bind(this));
    }

    $onInit() {
      this.group = this.resolve.group || {};
    }

    async save({ group }) {
      try {
        if (group.id) {
          const resp =  await this.Finance.updateGroup(group);
          this.modalInstance.close(resp);
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
        } else {
          const resp =  await this.Finance.createGroup(group);
          this.modalInstance.close(resp);
          this.AlertBox.addMessage('alert.created', { type: 'success' });
        }
      } catch (e) {
        this.AlertBox.addMessage('alert.created', { type: 'error' });
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close(void(0));
    }

  }
};
